import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDN6fqo_C5Et_rW1d75mLwzxtUYMeq5Dms",
  authDomain: "contarte-b1e5f.firebaseapp.com",
  projectId: "contarte-b1e5f",
  storageBucket: "contarte-b1e5f.firebasestorage.app",
  messagingSenderId: "12332245669",
  appId: "1:12332245669:web:d6bcd7ad433b8f4a21a34c"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
